import { FormProvider } from 'react-hook-form';
import { Form } from './Form';
import { useTherapySuppliersForm } from 'Hooks/useTherapySuppliersForm';
import { useContext, useEffect } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Stack } from '@mui/material';
import { Title } from './Title';
import { LinkReturnToMain } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SUPPLIERS_STEPS } from 'Enum/suppliers';
import { useNavigate } from 'react-router-dom';

export const TherapySearchForm = () => {
  const { therapySuppliersForm } = useTherapySuppliersForm();
  const { setFilters, setStepIndex } = useContext(SuppliersContext);

  const navigate = useNavigate();

  const specialty = therapySuppliersForm.watch('specialty');
  useEffect(() => {
    setFilters({ specialty: therapySuppliersForm.getValues('specialty') });
  }, [setFilters, specialty, therapySuppliersForm]);

  return (
    <FormProvider {...therapySuppliersForm}>
      <LinkReturnToMain
        label={Dictionary[DICTIONARY.General].return}
        onClick={() => {
          setStepIndex(SUPPLIERS_STEPS.LOBBY);
          navigate('/suppliers');
        }}
      />
      <Stack gap={'16px'} alignItems={'center'}>
        <Title />
        <Form />
      </Stack>
    </FormProvider>
  );
};
